'use strict';

const { isEmpty } = require('lodash');
const formValidation = require('../components/formValidation');
const capencyVerifyEmail = require('capency/capency/email/capency.verify.email');
const capencyHelper = require('capency/capencyHelper');
const capencyVerfiyAddress = require('capency/capency/address/capency.verify');

/**
 *
 * @param {string} languages available languages
 */
function setLanguagesSelectList(languages) {
    var languagesList = languages.split(',');
    var select = '<select class="form-control checkout-select pl-4">';
    languagesList.forEach(function (lang) {
        select += '<option value="' + lang + '">' + lang + '</option>';
    });
    select += '</select>';
    $('.newsletterLanguages').html(select);
    $('.smsLanguages').html(select);
}
/**
 * Removes languages from DOM
 */
function unsetLanguagesSelectList() {
    $('.newsletterLanguages').empty();
    $('.smsLanguages').empty();
}

/**
* Submits validation for customer registration
*/
async function submitValidation() {
    $('.submit-customer-register').on('click', async function (e) {
        e.preventDefault();
        try {
            if (capencyHelper.isCapencyEnabled('phone')) {
                if (!capencyHelper.validatePhone()) return;
            }

            let $emailSelector = $('.registration input[name$="dwfrm_profile_customer_email"]');
            let emailCheck = true;
            if (capencyHelper.isCapencyEnabled('email')) {
                emailCheck = await capencyVerifyEmail.checkEmailPropertyResult($emailSelector);
            }

            let addressVerification = true;
            if (capencyHelper.isCapencyEnabled('address') && capencyHelper.isAddressFormModified()) {
                let result = await capencyVerfiyAddress.capencySearchAddress();
                addressVerification = await capencyVerfiyAddress.handleAddressVerification(result);
            }

            if (emailCheck && addressVerification) {
                submitAccount();
            } else {
                console.warn('Email check or address verification failed.');
            }
        } catch (error) {
            console.error('Error during address verification:', error);
        }
    });
}

/**
 * Ajax Call to register account
 */
function submitAccount() {
    $('#pwd-error').remove();

    var form = $('#dwfrm_profile');
    var url = form.attr('action');

    const $phoneField = form.find("[name='dwfrm_profile_customer_phone']");
    let fieldValue = $phoneField.val();
    let serializedData = form.serialize();
    let combinedData = serializedData.replace(/(dwfrm_profile_customer_phone=)[^&]+/, '$1' + encodeURIComponent(fieldValue));
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: combinedData,
        success: function (data) {
            $.spinner().stop();
            const isSuccess = !data.error || data.success;
            if (isSuccess && data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else if (data.hasError) {
                capencyVerfiyAddress.invalidateRegisteredAddress();
                formValidation(form, data);
                $phoneField.next('.invalid-feedback').show();
            }
        },
        error: function (err) {
            $.spinner().stop();
            var msg = err.responseJSON && err.responseJSON.errorMessage ? err.responseJSON.errorMessage : false;
            if (msg) {
                $('form#dwfrm_profile').prepend('<div id="pwd-error" class="alert alert-danger" role="alert">'
                    + msg + '</div>');
                $(window).scrollTop(0);
                $('.custom-control-label').addClass('error');
            }
        }
    });
}

/**
* Handles the country selection in the account registration page
* @param {string} [hiddenSelector='#country'] - the hidden selector for the country code
*/
function handleCountrySelection(hiddenSelector = '#country') {
    $(document).ready(function () {
        const languageOption = $('.account-country-selector .dropdown-country-selector .dropdown-item');
        const selectedCountry = $('input#country');
        let languages = languageOption.data('languages');

        if (selectedCountry[0].value.toLowerCase() === 'be' && languages) {
            setLanguagesSelectList(languages);
        }
    });
    $('body').on('mouseover', '.account-country-selector', function () {
        var $this = $(this);
        $this.find('.dropdown-menu').show();
    });
    $('body').on('mouseleave', '.account-country-selector', function () {
        var $this = $(this);
        $this.find('.dropdown-menu').hide();
    });
    $('body').off('click', '.account-country-selector .dropdown-item').on('click', '.account-country-selector .dropdown-item', function (evt) {
        evt.preventDefault();
        var $this = $(this);
        var languages = $this.data('languages');
        const countryCode = !isEmpty($this.data('id')) ? $this.data('id').toUpperCase() : $this.data('id');
        const form = $this.parents('form');
        form.find(hiddenSelector).val(countryCode);
        $this.parent().siblings('.js-dropdownCountrySelector').html($this.html()).find('.icon-pictoToteBag')
            .remove();

        if (!form.find('.address-form-phone').val()) {
            var phoneCode = $this.data('phonecode');
            form.find('.dropdown-phone-country-selector [data-phone-code="' + phoneCode + '"]').trigger('click');
        }

        if (languages) {
            setLanguagesSelectList(languages);
        } else {
            unsetLanguagesSelectList();
        }
        $this.closest('.dropdown-menu').hide();
    });
}

/**
 * Update phone number input with phone regex pattern
 */
function updatePhoneNumberInputPattern() {
    const $this = $(this);
    const pattern = $this.find('option:selected').data('pattern');

    const phoneInputID = getPhoneInputID($this);

    // Only applicable when in the account registration page
    if (isEmpty(pattern)) {
        $(phoneInputID).removeAttr('pattern');
    } else {
        $(phoneInputID).attr('pattern', pattern);
    }
}

/**
 * Set the phone number pattern on each phone number country change and on load
 */
function setPhoneNumberPattern() {
    $(document).ready(function () {
        updatePhoneNumberInputPattern.call($('#phoneCode'));
    });
    $('body').on('change', '#phoneCode', function () {
        updatePhoneNumberInputPattern.call(this);
    });
}

/**
 * Gets Phone Number input ID
 * @param {jQuery} $option select option element
 * @returns {string} phonenumber input ID in account registration form
 */
function getPhoneInputID($option) {
    let phoneInputID = '';
    const phoneInputID1 = '#registrationformphone';
    const phoneInputID2 = '#registration-form-phone';
    const phoneInputID3 = '#bookAddressPhone';
    const $phoneFormContainer = $option.closest('.phone-number-form-section');

    if ($phoneFormContainer.find(phoneInputID1).length) {
        phoneInputID = phoneInputID1;
    }
    if ($phoneFormContainer.find(phoneInputID2).length) {
        phoneInputID = phoneInputID2;
    }
    if ($phoneFormContainer.find(phoneInputID3).length) {
        phoneInputID = phoneInputID3;
    }

    return phoneInputID;
}

/**
 * Remove previous attribute checked state and reassign it to the current DOM input
 */
function setRadioOnChange() {
    $('body').on('click', 'input[type="radio"]', function () {
        var $this = $(this);
        var name = $this.attr('name');
        $('[name="' + name + '"]').removeAttr('checked');
        $this.prop('checked', 'checked');
    });
}

/**
* Handles the phone country selection in the account registration page
* @param {string} [hiddenSelector='#country'] - the hidden selector for the country code
*/
function handlePhoneCountrySelection(hiddenSelector = '#phoneCode') {
    $('body').on('mouseover', '.account-phone-country-selector', function () {
        var $this = $(this);
        $this.find('.dropdown-menu').show();
    });
    $('body').on('mouseleave', '.account-phone-country-selector', function () {
        var $this = $(this);
        $this.find('.dropdown-menu').hide();
    });
    $('body').off('click', '.account-phone-country-selector .dropdown-item').on('click', '.account-phone-country-selector .dropdown-item', function (evt) {
        evt.preventDefault();
        let $this = $(this);
        let $form = $this.closest('form');
        let $phoneCodeField = $(hiddenSelector, $form);
        let $countryData = $this.find('i').data();
        const $phoneBlock = $('.phone-number-block', $form);
        let $phoneInput = null;

        Object.keys(forms).forEach(key => {
            let formId = forms[key].id;
            if ($phoneBlock.find(formId).length) {
                $phoneInput = $phoneBlock.find(formId);
                return false;
            }
            return true;
        });
        const $phonePrefixField = $phoneBlock.find('.phone-prefix-field');
        let phoneCode = !isEmpty($countryData) ? $countryData.phoneCode : '';
        let $phoneCountrySelector = $this.parent().siblings('.js-dropdownPhoneCountrySelector');
        $phoneCodeField.val(phoneCode);
        $phoneCodeField.data('countryCode', $countryData.countrycode);
        $phoneCountrySelector.html($this.html());
        $phonePrefixField.text(phoneCode);
        capencyHelper.removeFieldValidationResults($phoneInput);
        $phoneInput.trigger('change');
        $this.closest('.dropdown-menu').hide();
    });
}

let forms = {
    addressBook: {
        id: '#bookAddressPhone'
    },
    register: {
        id: '#phone'
    },
    checkoutShipping: {
        id: '.shippingPhoneNumber'
    },
    editAddressForm: {
        id: '#shippingPhoneNumber'
    },
    dwfrm_address: {
        id: 'shippingPhoneNumberdefault'
    }
};

module.exports = {
    helpers: {
        submitValidation: submitValidation,
        handleCountrySelection: handleCountrySelection,
        handlePhoneCountrySelection: handlePhoneCountrySelection,
        setPhoneNumberPattern: setPhoneNumberPattern,
        setRadioOnChange: setRadioOnChange
    }
};
